import { useCallback, useEffect, useState } from "react";
import { fetchOrders } from "../api/historyApi";

// Хүргэгдсэн/дууссан захиалгын статусууд (5, 6).
const DELIVERED_STATUS_IDS = [5, 6];

// Захиалгын түүхийг огнооны мужаар ачаална. Дэлгэц зөвхөн ҮҮНИЙГ дуудна.
// loadError: сүлжээ/серверийн алдаа («захиалга байхгүй»-гээс ялгана).
export function useOrderHistory(startDate, endDate) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const refetch = useCallback(async () => {
    setLoading(true);
    setLoadError(false);
    try {
      const res = await fetchOrders({
        statusIds: DELIVERED_STATUS_IDS,
        startDate,
        endDate,
        page: 1,
        limit: 1000,
      });
      setItems(res?.success && res.data ? res.data : []);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setItems([]);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { items, loading, loadError, refetch };
}
